import React, { useState } from 'react';
import _ from 'lodash';
import DataTable from '~/components/datatable';
import { formats } from 'helper';
import { TableContainer } from '~/views/companies/styles';

const columns = [
    {
      name: 'CPF/Nº registro',
      width: '160px',
      selector: 'identify',
      format: (row) => formats.cpf(_.get(row, 'identify')) || _.get(row, 'identify') || ''
    },
    {
      name: 'Nome',
      selector: 'name',
      wrap: true,
      format: (row) => _.get(row, 'name') || ''
    },
    {
      name: 'Função',
      selector: 'role',
      width: '140px',
      wrap: true,
      format: (row) => _.get(row, 'role.name') || ''
    }
  ];

const getRows = (array = [], offset, pageSize) => {
  return array.slice(offset, offset + pageSize);
};

export const TabPersons = ({ persons }) => {
  const count = _.size(persons);
  const pageSize = 50;
  const [ offset, setOffset ] = useState(0);

  const onChangePage = (offset) => {
    setOffset(offset);
  };

  return (
    <TableContainer>
      <DataTable
        emptyText="Nenhum colaborador vinculado"
        pageSize={pageSize}
        onChangePage={onChangePage}
        data={{ rows: getRows(persons, offset, pageSize), offset, count, limit: pageSize }}
        onRowClicked={_.noop}
        columns={columns}
        />
    </TableContainer>
  )
};